var moduleMap = {
	"./ManagementApp": () => {
		return Promise.all([__webpack_require__.e(8483), __webpack_require__.e(7873), __webpack_require__.e(9487), __webpack_require__.e(4101), __webpack_require__.e(1265), __webpack_require__.e(21), __webpack_require__.e(9933), __webpack_require__.e(9333), __webpack_require__.e(9770), __webpack_require__.e(309), __webpack_require__.e(3326), __webpack_require__.e(7257)]).then(() => (() => ((__webpack_require__(13896)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});